import { IndustryTemplate } from '@/components';
import { applianceRepairContent } from '@/data/industries/appliancerepair';

export function ApplianceRepairPage() {
  return <IndustryTemplate content={applianceRepairContent} />;
}
